import { render, staticRenderFns } from "./NewSurvey.vue?vue&type=template&id=72574560&"
import script from "./NewSurvey.vue?vue&type=script&lang=js&"
export * from "./NewSurvey.vue?vue&type=script&lang=js&"
import style0 from "./NewSurvey.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NewSurvey.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports